import type { FaireProductEntity } from "../../entity_types/product";

export const p_qg24mbvu3m: FaireProductEntity = {
  token: "p_qg24mbvu3m",
  type: "product",
  name: "Book Pumpkin Fall Decor- Thanksgiving Halloween Hosting Gift",
  brandToken: "b_hdzdhxjbj6",
  brandName: "Root To Vine",
  imageUrl:
    "https://cdn.faire.com/fastly/1f4a2232a97caddf94ace65bec8678dcd779cdf3a9a6b41aa0588252da5deb1b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c4b43649d621c7b82bc7eb83181e7d35a9e6415c7f3660c2170e01914b4b687.jpeg",
    "https://cdn.faire.com/fastly/7ce3dddde4c3c078464790d0faad999a7f7aa11ea31f260e15a74a394f9d9dfd.jpeg",
    "https://cdn.faire.com/fastly/49a9e8bc4e52329214c24281946cd58093a85590b3321850b7a819db16a7d2ec.jpeg",
    "https://cdn.faire.com/fastly/89225ba5f59e89123497c15c989b264d0d7d5991460b365cf13c3dd2480f74cd.jpeg",
    "https://cdn.faire.com/fastly/4cf5c7240b7108d82bdd1e93c11a79dbf975aec2650f270e4f4e3885fa1f40a7.jpeg",
  ],
  priceDollars: 10.5,
  description:
    'These handmade pumpkins are crafted from cast-off literature, transforming book pages into stunning fall decor and Thanksgiving table centerpieces. Perfect as an eco-friendly bookish gift or autumn home accent, they add cozy charm to your harvest decor or holiday display.\n\nOur book pumpkins ship flat so the pages do not bend and become damaged. Upon arrival you need to open them within several days time so they can spread back open. Simple instructions will be included and involve using a hair dryer to fluff them back out along with paperclips if needed. \n\nEach book pumpkin will look slightly different and there may be small gaps once opened. \n\nDimensions\nSmall: 5" x 3 1/2"\nMedium: 8" x 5"\nLarge: 9" x 6"\n',
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:28:38.513Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
